// ElevenLabs (Scribe v2 Realtime) credentials. Deliberately frontend-only (no
// backend proxy yet), so the key ships in the bundle — use a usage-capped key
// scoped to this internal tool. The key never rides the WebSocket itself: it
// mints 15-minute single-use tokens (see transcription-socket.ts). Absent key
// ⇒ the transcript UI stays in its disabled placeholder state.
const ELEVENLABS_KEY = import.meta.env['VITE_ELEVENLABS_API_KEY']

export function transcriptionApiKey(): string | undefined {
  return typeof ELEVENLABS_KEY === 'string' && ELEVENLABS_KEY !== ''
    ? ELEVENLABS_KEY
    : undefined
}
